import React, { useEffect } from 'react';

const pyrhonScript = '/phyron2.js';
const pyrhonSearch = 'phyron.com';

const checkIfScriptTagExist = (url: string) => {
  const scripts = document.getElementsByTagName('script');
  for (let i = scripts.length; i--; ) {
    if (scripts[i].src == url) return true;
  }
  return false;
};

interface PyrhonPlayerProps {
  url: string;
}

const PyrhonPlayer = ({ url }: PyrhonPlayerProps) => {
  useEffect(() => {
    const pyhronMediaUrl = url.includes(pyrhonSearch);
    if (pyhronMediaUrl) {
      const index = url.indexOf(pyrhonSearch) + pyrhonSearch.length;
      const scriptUrl = `${url.slice(0, index)}${pyrhonScript}`;
      if (!checkIfScriptTagExist(scriptUrl)) {
        const s = document.createElement('script');
        s.src = scriptUrl;
        s.setAttribute('async', '');
        document.body.appendChild(s);
      }
    }
  }, [url]);

  const splitted = url.split('/');
  const repoIndex = splitted.findIndex((x) => x === 'repo');

  const pyrhonVrm = repoIndex > -1 ? splitted[repoIndex + 1] : undefined;

  return (
    <div style={{ display: 'none' }}>
      <video
        className="phyron-video"
        data-campaign="rejmes-bil"
        data-product-key={pyrhonVrm}
        data-file="1024x768"
        data-tracking-source="phyron"
        src={url}
        poster={url.replace('.mp4', '.jpg')}
        preload="none"
      />
    </div>
  );
};

export default PyrhonPlayer;
